
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

interface PasswordFormData {
  currentPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css'],
})
export class ChangePasswordComponent implements OnInit {
  @Input() currentEmail: string = ''; 
  
  passwordForm: FormGroup;
  submitted = false;

  constructor(private fb: FormBuilder, private translate: TranslateService) {
    this.passwordForm = this.fb.group(
      {
        currentPassword: [
          '',
          [
            Validators.required,
            // Validators.minLength(8),
            // Validators.maxLength(100),
            // Validators.pattern(
            //   /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/
            // ),
          ],
        ],
        newPassword: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(100),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\da-zA-Z]).{8,}$/
            ),
          ],
        ],
        confirmNewPassword: ['', Validators.required],
      },
      { validators: [this.passwordsMatch, this.newPasswordDifferent] }
    );
  }

  ngOnInit(): void {
    console.log('Email from parent:', this.currentEmail);
  }

  get f() {
    return this.passwordForm.controls;
  }

  // Custom validator for matching new passwords
  passwordsMatch(form: FormGroup) {
    const newPass = form.get('newPassword')?.value;
    const confirmPass = form.get('confirmNewPassword')?.value;
    
    if (!newPass || !confirmPass) {
      return null;
    }
    
    return newPass === confirmPass ? null : { passwordMismatch: true };
  }

  // Custom validator to ensure new password is different from current password
  newPasswordDifferent(form: FormGroup) {
    const currentPass = form.get('currentPassword')?.value;
    const newPass = form.get('newPassword')?.value;
    
    if (!currentPass || !newPass) {
      return null;
    }
    
    return currentPass !== newPass ? null : { sameAsCurrent: true };
  }

  // Helper method to check specific errors
  hasError(errorName: string): boolean {
    return this.passwordForm.hasError(errorName);
  }

  // Get error message for specific field
  getErrorMessage(controlName: string): string {
    const control = this.passwordForm.get(controlName);
    if (control?.errors && control.touched) {
      if (control.errors['required']) {
        return this.getTranslatedMessage(`${controlName}Required`);
      }
      if (control.errors['minlength'] || control.errors['maxlength']) {
        return this.getTranslatedMessage('passwordLengthError');
      }
      if (control.errors['pattern']) {
        return this.getTranslatedMessage('passwordPatternError');
      }
    }
    return '';
  }

  // Get form-level error messages
  getFormErrorMessage(): string {
    if (this.passwordForm.errors?.['passwordMismatch']) {
      return this.getTranslatedMessage('passwordMismatchError');
    }
    if (this.passwordForm.errors?.['sameAsCurrent']) {
      return this.getTranslatedMessage('newPasswordSameAsCurrentError');
    }
    return '';
  }

  private getTranslatedMessage(key: string): string {
   
    const messages: { [key: string]: string } = {
      'passwordMismatchError': 'كلمة المرور الجديدة وتأكيد كلمة المرور غير متطابقين',
      'newPasswordSameAsCurrentError': 'كلمة المرور الجديدة يجب أن تكون مختلفة عن كلمة المرور الحالية',
      'currentPasswordRequired': 'كلمة المرور الحالية مطلوبة',
      'newPasswordRequired': 'كلمة المرور الجديدة مطلوبة',
      'confirmNewPasswordRequired': 'تأكيد كلمة المرور الجديدة مطلوب',
      'passwordLengthError': 'كلمة المرور يجب أن تكون بين 8 و 100 حرف',
      'passwordPatternError': 'كلمة المرور يجب أن تحتوي على حرف كبير، حرف صغير، رقم، وحرف خاص'
    };
    return messages[key] || key;
  }

  onSubmit(): void {
    this.submitted = true;
    
    if (this.passwordForm.valid) {
      const formData: PasswordFormData = this.passwordForm.value;
      
      const requestData = {
        email: this.currentEmail, 
        ...formData
      };
      
      console.log('✅ Form Data with Email:', requestData);
      
      // this.messageService.add({
      //   severity: 'success',
      //   summary: 'Success',
      //   detail: this.translate.instant('passwordUpdateSuccess'),
      // });

      this.passwordForm.reset();
      this.submitted = false;
    }
  }
}